import { colors } from "../shared/constants";
import { LuFile, LuFileText, LuImage } from "react-icons/lu";

export function formatBytes(bytes) {
  if (!bytes) return "";
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
}

export function formatDate(dt) {
  if (!dt) return "";
  return new Date(dt).toLocaleDateString("en-AU", { day: "2-digit", month: "short", year: "numeric" });
}

export function fileIcon(name, size = 20) {
  const ext = (name || "").split(".").pop().toLowerCase();
  if (ext === "pdf") return <LuFileText size={size} style={{ color: colors.blue, flexShrink: 0 }} />;
  if (["jpg", "jpeg", "png", "gif", "webp", "heic"].includes(ext))
    return <LuImage size={size} style={{ color: colors.teal, flexShrink: 0 }} />;
  if (["doc", "docx"].includes(ext)) return <LuFileText size={size} style={{ color: colors.blue, flexShrink: 0 }} />;
  if (["xls", "xlsx", "csv"].includes(ext)) return <LuFileText size={size} style={{ color: colors.green, flexShrink: 0 }} />;
  return <LuFile size={size} style={{ color: colors.slate, flexShrink: 0 }} />;
}
